import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FileDownloadControlDto } from 'src/app/data/models/dto/file.dto';
import { FileService } from 'src/app/data/services/file.service';
import { FileUtils } from 'src/app/data/utils/file.utils';

@Component({
  selector: 'app-file-uploaded-item',
  templateUrl: './file-uploaded-item.component.html',
  styleUrls: ['./file-uploaded-item.component.scss'],
})
export class FileUploadedItemComponent implements OnInit {
  @Input() filePathOldStructure: string = '';
  @Input() fileData!: FileDownloadControlDto;
  @Input() allowDelete!: boolean;
  @Input() imgURL: any;
  file: File | undefined;
  pdfIcon = '../../../../assets/icons/pdf-img.png';
  imageIcon = '../../../../assets/icons/file_download.png';
  @Output() onDeleteEmitter = new EventEmitter<boolean>();

  constructor(
    private cookieService: CookieService,
    private fileService: FileService,
    private fileUtils: FileUtils
  ) {}

  ngOnInit(): void {
    this.file = this.fileData.file;
  }

  fileExtension(fileName: string) {
    return this.fileUtils.fileExtension(fileName);
  }

  fileSize() {
    return this.file ? this.fileUtils.formatBytes(this.file.size) : '';
  }

  fileInfoExists() {
    return this.file;
  }

  isImage(name: string) {
    return this.fileUtils.isImage(name);
  }

  async onDownloadClick(
    item: FileDownloadControlDto,
    event: any
  ): Promise<void> {
    if (item.isActive === false && event) {
      item.processing = new Subject<boolean>();
      item.processing.next(false);
      const arqFile = await this.getFile(item);
      if (arqFile) {
        this.filePreview(arqFile);
        saveAs(arqFile, item.name!);
        item.isActive = true;
        this.file = arqFile;
      }
    } else {
      item.processing?.next(!event);
    }
  }

  private getFile(fileDto: FileDownloadControlDto): Promise<File> {
    const object = new Promise<File>(async (resolve, reject) => {
      try {
        const arrayBuffer = await this.fileService
          .downloadByUrlPath(fileDto.path)
          .pipe(takeUntil(fileDto.processing!.asObservable()))
          .toPromise();
        const arqFile = this.fileUtils.FromByteArrayToFile(
          arrayBuffer,
          fileDto.name
        );
        resolve(arqFile);
      } catch (error) {
        console.log('error to downloadFile: ', error);
        reject(new File([''], ''));
      }
    });
    return object;
  }

  private filePreview(file: File) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    };
  }

  async onRemoveFileClick() {
    this.onDeleteEmitter.emit(true);
  }
}
